export default __webpack_public_path__ + "static/media/wow-grey-px14.2bc0ac3b.svg";